import { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';

export const allowedScenarios = [
  SCENARIO_STEP.GO_TO_LEADGEN,
  SCENARIO_STEP.CREDIT_OFFERS_LOADING,
  SCENARIO_STEP.CREDIT_SELECTION,
  SCENARIO_STEP.OFFER_DISBURSEMENT,
  SCENARIO_STEP.CONDITIONS_SELECTION,
  SCENARIO_STEP.DOCUMENTS_LOADING,
  SCENARIO_STEP.OFFER_APPROVAL,
  SCENARIO_STEP.AGREEMENT_SIGNING,
  SCENARIO_STEP.OFFER_COOLING_PERIOD,
  SCENARIO_STEP.FRAUD_RISK_DETECTED,
  SCENARIO_STEP.FRAUD_PREVENTION,
  SCENARIO_STEP.CARD_DELIVERY_INVITE,
  SCENARIO_STEP.ERROR_STEP,
  SCENARIO_STEP.AGREEMENT_SIGNED,
  SCENARIO_STEP.CLIENT_REFUSED,
  SCENARIO_STEP.CREDIT_SELF_RESTRICTION,
] as const;
